import { Stack } from '@mui/material';
import { useBoundStore } from 'useStore';
import useBrandsData from 'views/Components/Shared/Queries/brandsQuery';
import FilterChip from './utils/FilterChip';

export default function BrandFilterChip() {
	const brandsQuery = useBrandsData();
	const selectedBrand = useBoundStore(
		(state) => state.productMasterSelectedBrand
	);
	const resetSelectedBrand = useBoundStore(
		(state) => state.clearProductMasterSelectedBrand
	);

	if (selectedBrand.length === 0) return null;

	const brand = brandsQuery.data?.find((b) => b.brand === selectedBrand);

	return (
		<Stack direction="row" flexWrap="wrap" gap={1}>
			<FilterChip
				icon={brand?.brand}
				brand={true}
				filterName="Brand"
				title={brand?.brand}
				onDelete={() => resetSelectedBrand()}
			/>
		</Stack>
	);
}
